<template>
    <div>
        <div class="row d-flex align-items-center">
            <div class="col-9 mb-1">
                <small>
                    <span v-html="labelEndereco"></span>
                    <div class="lh-18 ps-3" v-html="strEndereco"></div>
                </small>
            </div>
            <div class="col-3 text-end" v-if="temEndereco && endereco.logradouro != '@BASE PRESTADOR' && statusBotaoCorrigirEndereco">
                <BotaoUsarLocalizacao 
                    :corrigir="true" 
                    :tipoEndereco="tipoEndereco" 
                    :endereco="endereco"
                    :segundaSaida="segundaSaida" 
                />
            </div>
        </div>
        <ModalLocalizacao :idServicoAtendimento="idServicoAtendimento" />
    </div>
</template>

<script setup>
import BotaoUsarLocalizacao from '@/components/Botoes/BotaoUsarLocalizacao.vue';
import ModalLocalizacao from '@/components/Modais/ModalLocalizacao.vue';
import { defineProps, ref, computed, watch } from 'vue';
import { montarEndereco } from '@/helper/funcoes.js';

const props = defineProps({
    tipoEndereco: String,
    endereco: Object,
    segundaSaida: {
        type: Boolean,
        default: false
    },
    status: String,
    idServicoAtendimento: String
});

let strEndereco = ref('');

const labelEndereco = computed(() => {
    let cor = 'text-danger';
    let texto = 'Destino em';
    if (props.tipoEndereco == 'Origem') {
        cor = 'text-success';
        texto = 'Origem em';
    }

    return `<span class="material-symbols-outlined ${cor}">location_on</span> ${texto}:`
});
const temEndereco = computed(() => strEndereco.value != 'Não infornado');
const statusBotaoCorrigirEndereco = computed(() => {
    return [
        'PRESTADOR_A_CAMINHO',
        'PRESTADOR_CHEGOU_LOCAL',
        'VIAJANDO_PARA_DESTINO',
        'FINALIZADO',
        'CANCELADO'
    ].indexOf(props.status) < 0;
})

watch(() => (strEndereco.value = montarStrEndereco(props.endereco)));

function montarStrEndereco(endereco) {
    if (endereco.logradouro == '@BASE PRESTADOR') {
        return 'O destino deste atendimento será a base do prestador';
    }

    const str = montarEndereco(endereco);
    if (str) {
        return str;
    }
    return 'Não infornado';
}

</script>